import { cn } from '@listening/utils/react-helpers';
import * as SliderPrimitive from '@radix-ui/react-slider';
import type * as React from 'react';

const Slider = ({
  ref,
  className,
  thumbClassName,
  rangeClassName,
  trackClassName,
  rangeComponent,
  trackChildren,
  ...props
}: React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root> & {
  thumbClassName?: string | null;
  rangeClassName?: string;
  trackClassName?: string;
  rangeComponent?: React.ReactNode;
  trackChildren?: React.ReactNode;
} & {
  ref?: React.RefObject<React.ComponentRef<typeof SliderPrimitive.Root> | null>;
}) => (
  <SliderPrimitive.Root
    className={cn(
      'relative flex w-full touch-none items-center select-none',
      className,
    )}
    ref={ref}
    {...props}
  >
    <SliderPrimitive.Track
      className={cn(
        'relative h-2 w-full grow overflow-hidden rounded-full bg-secondary',
        trackClassName,
      )}
    >
      {rangeComponent ? (
        // Render rangeComponent if it's provided
        <SliderPrimitive.Range
          asChild
          className={cn('absolute h-full', rangeClassName)}
        >
          <span className='overflow-hidden'>{rangeComponent}</span>
        </SliderPrimitive.Range>
      ) : (
        // Fall back to the default range if rangeComponent is not provided
        <SliderPrimitive.Range
          className={cn('absolute h-full bg-primary', rangeClassName)}
        />
      )}
      {trackChildren}
    </SliderPrimitive.Track>
    {thumbClassName !== null && (
      <SliderPrimitive.Thumb
        className={cn(
          'block h-5 w-5 rounded-full border-2 border-primary bg-background ring-offset-background transition-colors focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:outline-hidden disabled:pointer-events-none disabled:opacity-50',
          thumbClassName,
        )}
      />
    )}
  </SliderPrimitive.Root>
);
Slider.displayName = SliderPrimitive.Root.displayName;

export { Slider };
